import desktopBg from '@/public/assets/svg/desktop-bg.svg';
import desktopDevice from '@/public/assets/svg/desktopDevice.svg';
import Image from 'next/image';

const SmallerScreensModal = () => {
  return (
    <div
      className={`fixed inset-0 z-50 block overflow-hidden bg-white bg-cover bg-center sm:hidden`}
      style={{ backgroundImage: `url(${desktopBg.src})` }}
    >
      <div className="flex h-screen w-full flex-col items-center justify-center overflow-hidden p-4 shadow-lg sm:w-full">
        <Image src={desktopDevice} alt="desktop-only" />
        <p className="text-[18px] font-[600] text-[#145121]">
          Best For Larger Screens
        </p>
        <p className="mt-5 w-full text-center text-[#6B7280] sm:w-[40%]">
          For the best experience, we recommend using Darcy on a desktop or
          laptop
        </p>
      </div>
    </div>
  );
};

export default SmallerScreensModal;
